import React, { useEffect, useState } from 'react';
import { SearchList } from '../../../../components/lists/search-list';
import { ListItem } from '../../../../components/lists/list-item';
import { useAppActions, useAppState } from '../../../../overmind';
import { IRoleComparisonListProps, Role } from './role-comparison.models';
import { PagingSearchParams, SearchingSearchParams } from '../../../../models/overmind/search-params';
import { useMatchScreenWidth } from '@keplerco/core';

export function RoleComparisonList({ pendingRoleSlug, setPendingRole }: IRoleComparisonListProps): JSX.Element {
  const actions = useAppActions();
  const { companyVariables } = useAppState();

  const isMobile = useMatchScreenWidth('mobile');

  const [loading, setLoading] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useState<SearchingSearchParams & PagingSearchParams>({
    search: undefined,
    page: 1,
    pageSize: 5,
  });
  const [roles, setRoles] = useState<Role[]>();
  const [totalPages, setTotalPages] = useState<number>(0);

  useEffect(() => {
    async function getData() {
      setLoading(true);

      const response = await actions.getCompanyRoles({
        page: searchParams.page ?? 1,
        pageSize: searchParams.pageSize ?? 10,
        search: searchParams.search,
        sortAscending: true,
        companySlug: companyVariables.slug,
        searchGlobally: false,
        active: true
      });
      setRoles(
        response?.roles.map(role => ({
          name: role.name,
          slug: role.slug!,
          description: role.description,
        }))
      );
      setTotalPages(response?.totalPages ?? 0);

      setLoading(false);
    }

    getData();
  }, [searchParams, companyVariables.slug]);

  return (
    <div className="card">
      <SearchList
        loading={loading}
        onInput={search => setSearchParams({ page: 1, pageSize: 5 , search })}
        paging={{
          activePageNumber: searchParams.page ?? 1,
          pageCount: totalPages,
          onPageChange: page => setSearchParams(currentState => ({ ...currentState, page })),
        }}
        emptyState
      >
        {roles?.map(role => {
          const selected = role.slug === pendingRoleSlug;
          return (
            <ListItem key={role.slug} selected={selected} onClick={() => setPendingRole(selected ? undefined : role)}>
              <div style={{ display: 'grid', gap: 15, alignItems: 'center', gridTemplateColumns: isMobile ? '1fr' : '1fr 3fr' }}>
                <span style={{ color: 'var(--accent-2)' }}>{role.name}</span>
                <small>{role.description ?? 'No description provided'}</small>
              </div>
            </ListItem>
          );
        })}
      </SearchList>
    </div>
  );
}
